export default __webpack_public_path__ + "static/media/manual05.453b7e61.png";